import React, { useState } from 'react';
import { Button, Popover } from 'reactstrap';
import './ballon.css'

const Ballon = (props) => {
    var d = props.data
    var pos = "top"
    if (props.nRows < 4) {
        pos = 'left'
    }

    const [popoverOpen, setPopoverOpen] = useState(false);
    const toggle = () => setPopoverOpen(!popoverOpen);

    return (
        <div className='audit'>
            <div className='audit-button'>
                {d.edit ? (
                    <Button id={`popover${props.id}`} type="button" className='a-b-edit'><span className='a-b-edit-text'>{props.status}</span></Button>
                ) : (
                  <Button id={`popover${props.id}`} type="button" className={d.pass ? 'a-b-pass' : 'a-b-negative'} />
                )}
            </div>
            {d.edit ? (
                <Popover placement={pos} isOpen={popoverOpen} target={`popover${props.id}`} toggle={toggle} className='audit-popover' trigger="legacy">
                    <div className='audit-card audit-card-common'>
                        {props.children}
                    </div>
                </Popover>
            ) : !d.pass ? (
                <Popover placement={pos} isOpen={popoverOpen} target={`popover${props.id}`} toggle={toggle} className='audit-popover' trigger="legacy">
                    <div className={`audit-card ${d.pass ? 'audit-card-pass' : ''}`}>
                        {d.content.map((d, i) => {
                            return <p key={i}>{d}</p>
                        })}
                    </div>
                </Popover>
            ) : null
            }
        </div>
    );
}

export default Ballon